import type { LeadershipPageData, PageProps } from "@/types";
import React, { FC } from "react";
import { TextCols } from "../text-cols";
import { LeadershipLeader } from "../leadership";
import { NextPage } from "../next-page";

export const Leadership: FC<PageProps<LeadershipPageData>> = (props) => {
  React.useEffect(() => {
    const handleScroll = () => {
      const leadersElements = Array.from(
        document.querySelectorAll(".leadershipLeader--name")
      );

      leadersElements.forEach((leader) => {
        const rect = leader.getBoundingClientRect();

        // Check if the leader element is in the viewport
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
          const anchorId = leader.id;
          const anchor = document.querySelector(`a[href="#${anchorId}"]`);

          if (anchor) {
            anchor.classList.add("active");
          }
        } else {
          const anchorId = leader.id;
          const anchor = document.querySelector(`a[href="#${anchorId}"]`);

          if (anchor) {
            anchor.classList.remove("active");
          }
        }
      });
    };

    // Attach scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Call handleScroll on initial load
    handleScroll();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="leadershipPage">
      <div className="wrapper">
        <TextCols
          label="About Us"
          headingLevel="h1"
          content={{
            title: "Leadership",
          }}
          className="leadershipPage--hero"
        />
        <div className="leadershipPage--grid">
          <div className="leadershipPage--sideLinks">
            <div className="leadershipPage--sideLinks-title">Our Leaders</div>
            <ul className="leadershipPage--sideLinks-list">
              {props.data.leaders.map((leader, index) => (
                <li key={index}>
                  <a href={`#${leader.name.toLowerCase().replace(/ /g, "-")}`}>
                    {leader.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="leadershipPage--leaders">
            {props.data.leaders.map((leader, index) => (
              <LeadershipLeader key={index} {...leader} />
            ))}
          </div>
        </div>
      </div>
      <NextPage {...props.data.nextPage} />
    </div>
  );
};
